import styled, { css,keyframes } from "styled-components";

export const Box = styled.div`
${({ width }) => width && `width: ${width};`}
${({ height }) => height && `height: ${height};`}
${({ borderRadius }) => borderRadius && `border-radius: ${borderRadius};`}
${({ lineHeight }) => lineHeight && `line-height: ${lineHeight};`}
  img,
  > svg {
    width: 100%;
  }
`;
